<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="部门名称"
            v-model:value="searchForm.deptName"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item></a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="部门列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button @click="toAdd" type="primary">添加</a-button>
      </template>

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :row-key="(r) => r.deptId"
        :loading="loading"
        style="overflow-y:scroll"
      >
        <template v-slot:button="{ text, record }">
          <a-button type="primary" @click="edit(record)">编辑</a-button>
        </template>
      </a-table>
    </a-card>
    <a-modal
      v-model:visible="modalVisible"
      title="添加部门"
      @ok="handleOk"
      :destroyOnClose="true"
    >
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="上级部门" name="parentId">
          <df-selectDeptTreeSingle
            :model="submitForm"
            @setValue="setValue"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="部门名称" name="deptName">
          <a-input
            v-model:value="submitForm.deptName"
            placeholder="部门名称"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="部门排序" name="orderNum">
          <a-input-number
            v-model:value="submitForm.orderNum"
            placeholder="排序"
            :min="1"
            :max="100"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="负责人" name="leader">
          <a-input
            v-model:value="submitForm.leader"
            placeholder="负责人"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="联系电话" name="phone">
          <a-input
            v-model:value="submitForm.phone"
            placeholder="联系电话"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="联系邮箱" name="email">
          <a-input
            v-model:value="submitForm.email"
            placeholder="联系邮箱"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="部门状态" name="main">
          <a-radio-group
            v-model:value="submitForm.status"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 开启</a-radio-button>
            <a-radio-button value="1"> 关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import deptApi from "@axios/sys/dept";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";

export default {
  name: "deptIndex",
  components: {},
  setup() {
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    let submitForm = reactive({
      parentId: "0",
      deptName: "",
      status: "0",
      leader: "",
      phone: "",
      email: "",
      orderNum: "0",
    });

    const rules = {
      deptName: [
        { required: true, message: "请输入部门名称", trigger: "blur" },
      ],
    };

    let loading = ref(false);
    let modalVisible = ref(false);
    let searchForm = reactive({
      deptName: "",
    });
    let searchParams = reactive({
      deptName: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "部门名称",
        dataIndex: "deptName",
        width: 200,
      },
      {
        title: "部门排序",
        dataIndex: "orderNum",
        width: 100,
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "statusValue",
        width: 200,
        align: "center",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 200,
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    const searchAction = () => {
      searchParams.deptName = searchForm.deptName;
      getList();
    };
    //查询列表
    const getList = () => {
      loading.value = true;
      let params = {
        deptName: searchParams.deptName ? searchParams.deptName : null,
      };
      deptApi.deptTreeList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        list.value = res;
      });
    };

    const reset = () => {
      searchForm.deptName = "";
      searchAction();
    };

    const toAdd = () => {
      modalVisible.value = true;
      isedit.value = false;
      submitForm.parentId = "0";
      submitForm.deptName = "";
      submitForm.status = "0";
      submitForm.leader = "";
      submitForm.phone = "";
      submitForm.email = "";
      submitForm.orderNum = "1";
    };
    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          //添加账号
          if (isedit.value) {
            let params = {
              deptId: editid,
              parentId: submitForm.parentId,
              deptName: submitForm.deptName,
              status: submitForm.status,
              leader: submitForm.leader,
              phone: submitForm.phone,
              email: submitForm.email,
              orderNum: submitForm.orderNum,
            };
            deptApi.deptEdit(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            deptApi.addDept(submitForm).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //上级部门值
    const setValue = (val) => {
      console.log(val);
      submitForm.parentId = val;
    };

    let isedit = ref(false);
    let editid = "";
    const edit = (row) => {
      if (submitFormref) submitFormref.resetFields();
      editid = row.deptId;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.parentId = row.parentId;
      submitForm.deptName = row.deptName;
      submitForm.status = row.status;
      submitForm.leader = row.leader;
      submitForm.phone = row.phone;
      submitForm.email = row.email;
      submitForm.orderNum = row.orderNum;
    };

    getList();

    return {
      isedit,
      edit,
      names,
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      searchAction,
      reset,
      toAdd,
      modalVisible,
      moment,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      setsubmitForm,
      setValue,
    };
  },
};
</script>
